export const painPoints = [
  {
    emoji: '🧭',
    title: 'Non sai da dove iniziare',
    desc: 'Il processo sembra insormontabile. Questo metodo organizza tutto: valutazione, fase acuta, rinforzo e ritorno allo sport.',
  },
  {
    emoji: '🔤',
    title: 'Ti blocchi sulla scelta degli esercizi',
    desc: 'Impara a riconoscere i modelli di progressione e a prescrivere con intenzione clinica.',
  },
  {
    emoji: '🧩',
    title: 'Non riesci a costruire un protocollo completo',
    desc: 'Impara la struttura delle fasi per protocolli che abbiano senso dal primo giorno.',
  },
  {
    emoji: '🎯',
    title: 'Temi la recidiva',
    desc: 'Tirare a indovinare è pericoloso. Un quadro chiaro di "Return to Play" è ciò che tiene gli atleti al sicuro.',
  },
];
